<template>
    <FKBreadCrumb :page="$t('page.caregivers')">
        <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
        <FKBreadCrumbItem :page="patient_fullname" :to="`/patient/${patient.id}`" />
    </FKBreadCrumb>
    <PatientAnagraph :minimal="true" class="patient-info-header border-bottom cursor-pointer" @click="back" />
    <CaregiversList />
</template>
<style>
.patient-info-header.lead-info-box {
    margin-bottom: 0 !important;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";

import CaregiversList from "@/components/FK/Caregivers/CaregiversList.vue";
import stateStore from "@/utils/store";
import { PatientInfo, Role, UserInfo } from "@/utils/models/user.model";
import CONFIG from "@/utils/const/config"
import PatientAnagraph from "@/components/FK/PatientDetail/PatientAnagraph.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
    name: "CaregiversPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        PatientAnagraph,
        CaregiversList
    },
    data() {
        return {
            patient: this.$route.meta.patient as PatientInfo,
        }
    },
    computed: {
        config() { return CONFIG },
        updateEnabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'update') },
        patient_fullname(): string { return `${this.patient.firstname} ${this.patient.lastname}` },
        caregivers(): UserInfo[] { return this.patient.users?.filter((info) => info.role.type === Role.caregiver) ?? []; }
    },
    methods: {
        back() {
            this.$router.push(`/patient/${this.patient.id}`);
        }
    }
});
</script>